import { el, mount, logoImg } from '../lib/dom.js';
import { T } from '../lib/strings.js';
import { SCHOOL, fullAppName } from '../config/school.js';
import { signIn } from '../lib/auth.js';

export function loginScreen(root, onSuccess) {
  const email = el('input', {
    type: 'email', class: 'text-input', required: true,
    autocomplete: 'username', enterkeyhint: 'next', 'aria-label': T.email,
    placeholder: T.email,
  });
  const password = el('input', {
    type: 'password', class: 'text-input', required: true,
    autocomplete: 'current-password', enterkeyhint: 'go', 'aria-label': T.password,
    placeholder: T.password,
  });
  const error = el('p', { class: 'error hidden', role: 'alert' });
  const btn = el('button', { class: 'btn btn-primary btn-large', type: 'submit' }, T.signIn);

  async function submit(e) {
    e.preventDefault();
    error.classList.add('hidden');
    btn.disabled = true; btn.textContent = T.signingIn;
    try {
      const staff = await signIn(email.value.trim(), password.value);
      onSuccess(staff);
    } catch (err) {
      error.textContent = err.message;
      error.classList.remove('hidden');
      password.value = '';
      password.focus();
    } finally {
      btn.disabled = false; btn.textContent = T.signIn;
    }
  }

  mount(root, el('div', { class: 'login' },
    logoImg(SCHOOL.brand.logo, 'login-logo', SCHOOL.name),
    el('h1', { class: 'login-title' }, fullAppName()),
    el('form', { class: 'login-form', onSubmit: submit }, email, password, error, btn),
  ));

  queueMicrotask(() => email.focus());
}
